export default __webpack_public_path__ + "static/media/work-icon-card-img.d0eaa4f5.svg";